// @ts-expect-error no type declarations for superagent-promise
import superagentPromise from 'superagent-promise';
// @ts-expect-error no type declarations for superagent
import _superagent from 'superagent';
import { apiUrl } from '@shared/services/EnvironmentVariables';
import { getKioskToken } from '../storage/kioskStorage';

const superagent = superagentPromise(_superagent, Promise);

export class KioskUnauthorizedError extends Error {
  constructor() { super('Kiosk token rejected'); }
}

async function makeRequest(method: 'get' | 'post' | 'del', url: string, body?: any): Promise<any> {
  const fullUrl = `${apiUrl}${url}`;
  let req: any;
  if (method === 'del') req = superagent.del(fullUrl);
  else if (method === 'get') req = superagent.get(fullUrl);
  else req = superagent.post(fullUrl, body);

  const token = getKioskToken();
  if (token) req.set('x-kiosk-token', token);
  req.set('Content-Type', 'application/json');

  try {
    const res = await req;
    return res.body;
  } catch (err: any) {
    if (err && err.response && err.response.statusCode === 401) {
      throw new KioskUnauthorizedError();
    }
    if (err && err.response && err.response.text) {
      let message = err.response.text;
      try {
        message = JSON.parse(err.response.text).message || message;
      } catch { /* not JSON, use the raw text */ }
      throw new Error(message);
    }
    throw err;
  }
}

export const kioskAgent = {
  get: (url: string) => makeRequest('get', url),
  post: (url: string, body?: any) => makeRequest('post', url, body),
  del: (url: string) => makeRequest('del', url),
};
